<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
     _/                                                                                                                    _/
     _/      子画面定義：パスワード変更画面(STBPCM01C03)　　事業者用                                                                         _/
     _/                                                                                                                    _/
     _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
     <template>
      <BaseModal :show="isProcessShow">
        <div class="popup">
          <div class="popup-head">パスワード変更</div>
          <div class="loginbox blue" style="padding: 30px 30px">
            <!--
              ****  メッセージ表示領域 **** -->
            <p class="errMsg title-ico ico-warning alignleft" v-show="errors != ''">
              <ErrorMessage isModalError :errors="errors"></ErrorMessage>
            </p>
            <br />
            <P :style="{ 'text-align': this.TdsCssFlg == '1' ? 'left' : 'center' }">
              {{
                this.TdsCssFlg == "1"
                  ? "現在利用しているパスワードは継続して使用することができません。新しいパスワードを設定してください。"
                  : "新しいパスワードを設定してください。"
              }}
            </P>
            <p class="login-label alignleft ml-100px">新しいパスワード</p>
            <PasswordInput
              ref="refPassword1Input"
              v-model="newPassword"
              inputClass="frm-password"
              :hasError="isErrorNewPswInput"
            />
            <p class="errMsg alignleft ml-100px" v-show="errors_newpass != ''">
              <ErrorMessageCase :errors="errors_newpass"></ErrorMessageCase>
            </p>
            <p class="login-label alignleft ml-100px">新しいパスワードの再入力</p>
            <PasswordInput
              v-model="reNewPassword"
              inputClass="frm-password"
              :hasError="isErrorReNewPassword"
            />
            <p class="errMsg alignleft ml-100px" v-show="errors_renewpass != ''">
              <ErrorMessageCase :errors="errors_renewpass"></ErrorMessageCase>
            </p>
            <br />
            <p class="login-btn">
              <button
                tabindex="0"
                class="frm-btn strong large"
                type="button"
                @click="passwordChange"
                :disabled="passwordChangeDisabled"
                style="width: 180px"
              >
                パスワード変更
              </button>
              <button
                class="frm-btn large"
                @click="cancelAction"
                tabindex="0"
                ref="cancelButton"
                style="width: 180px"
              >
                キャンセル
              </button>
            </p>
          </div>
        </div>
      </BaseModal>
    </template>
    
    <!-- ********************************
         *******  スクリプト定義  *******
         ******************************** -->
    <script>
    import _ from "lodash";
    import BaseModal from "@/components/Base/BaseModal.vue";
    import ErrorMessage from "@/components/ErrorMessage.vue";
    import ErrorMessageCase from "@/components/ErrorMessageCase.vue";
    import Validation from "@/util/validation.js";
    import Common from "@/util/common.js";
    import PasswordInput from "@/components/PasswordInput.vue";
    
    export default {
      name: "STBPCM01C03PasswordChangeModal",
      components: {
        ErrorMessage,
        ErrorMessageCase,
        PasswordInput,
        BaseModal,
      },
      data() {
        return {
          errors: [],
          errors_newpass: [],
          errors_renewpass: [],
          newPassword: "",
          reNewPassword: "",
          isErrorNewPswInput: false,
          isErrorReNewPassword: false,
          msg: Common.getMessage("MTCL2070", []), //capslockメッセージ
          passwordChangeDisabled: false, // パスワード変更ボタン_活性状態
          retstatus: true,
        };
      },
      props: {
        isProcessShow: {
          type: Boolean,
          required: true,
        },
        // 変更前パスワード
        oldPassWord: {
          type: String,
          required: true,
        },
        //事業者ID
        tatsuzinId: {
          type: String,
          required: true,
        },
        //事務所or事業所
        TdsCssFlg: {
          type: String,
          required: true,
        },
      },
      watch: {
        isProcessShow: function (newVal) {
          if (newVal) {
            this.$nextTick(function () {
              this.initFocus();
            });
          }
        },
      },
      methods: {
        // **********************************************
        // パスワード変更
        // **********************************************
        passwordChange() {
          this.errors = [];
          this.errors_newpass = [];
          this.errors_renewpass = [];
          this.isErrorNewPswInput = false;
          this.isErrorReNewPassword = false;
          //新しいパスワード
          // 必須チェック
          if (!this.newPassword && this.newPassword !== 0) {
            this.isErrorNewPswInput = true;
            if (!this.errors || this.errors.length == 0) {
              this.errors.push(
                Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
              );
            }
            if (!this.errors_newpass || this.errors_newpass.length == 0) {
              this.errors_newpass.push(
                Common.createError(
                  "MTCL1001",
                  Common.getMessage("MTCL1001", ["新しいパスワード"])
                )
              );
            }
            this.retstatus = false;
            // 半角チェック
          } else if (
            !Validation.checkCharType(this.newPassword, "alphanumeric-symbol")
          ) {
            this.isErrorNewPswInput = true;
            if (!this.errors || this.errors.length == 0) {
              this.errors.push(
                Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
              );
            }
            if (!this.errors_newpass || this.errors_newpass.length == 0) {
              this.errors_newpass.push(
                Common.createError(
                  "MTCL1003",
                  Common.getMessage("MTCL1003", ["新しいパスワード"])
                )
              );
            }
            this.retstatus = false;
            //パスワードチェック
          } else if (!Validation.isPassword(this.tatsuzinId, this.newPassword)) {
            this.isErrorNewPswInput = true;
            if (!this.errors || this.errors.length == 0) {
              this.errors.push(
                Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
              );
            }
            if (!this.errors_newpass || this.errors_newpass.length == 0) {
              this.errors_newpass.push(
                Common.createError("MTCL1038", Common.getMessage("MTCL1038"))
              );
            }
            this.retstatus = false;
          } else {
            this.retstatus = true;
          }
    
          //新しいパスワードの再入力
          // 必須チェック
          if (!this.reNewPassword && this.reNewPassword !== 0) {
            this.isErrorReNewPassword = true;
            if (!this.errors || this.errors.length == 0) {
              this.errors.push(
                Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
              );
            }
            if (!this.errors_renewpass || this.errors_renewpass.length == 0) {
              this.errors_renewpass.push(
                Common.createError(
                  "MTCL1001",
                  Common.getMessage("MTCL1001", ["新しいパスワードの再入力"])
                )
              );
            }
            this.retstatus = false;
            // 半角チェック
          } else if (
            !Validation.checkCharType(this.reNewPassword, "alphanumeric-symbol")
          ) {
            this.isErrorReNewPassword = true;
            if (!this.errors || this.errors.length == 0) {
              this.errors.push(
                Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
              );
            }
            if (!this.errors_renewpass || this.errors_renewpass.length == 0) {
              this.errors_renewpass.push(
                Common.createError(
                  "MTCL1003",
                  Common.getMessage("MTCL1003", ["新しいパスワードの再入力"])
                )
              );
            }
            this.retstatus = false;
            //新しいパスワード=新しいパスワード再入力チェック
          } else if (this.newPassword != this.reNewPassword) {
            this.isErrorNewPswInput = true;
            this.isErrorReNewPassword = true;
            if (!this.errors || this.errors.length == 0) {
              this.errors.push(
                Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
              );
            }
            if (!this.errors_renewpass || this.errors_renewpass.length == 0) {
              this.errors_renewpass.push(
                Common.createError("MTCL1088", Common.getMessage("MTCL1088"))
              );
            }
            this.retstatus = false;
            //パスワードチェック
          } else if (!Validation.isPassword(this.tatsuzinId, this.reNewPassword)) {
            this.isErrorReNewPassword = true;
            if (!this.errors || this.errors.length == 0) {
              this.errors.push(
                Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
              );
            }
            if (!this.errors_renewpass || this.errors_renewpass.length == 0) {
              this.errors_renewpass.push(
                Common.createError("MTCL1038", Common.getMessage("MTCL1038"))
              );
            }
            this.retstatus = false;
          }
          //新しいパスワードが変更前パスワードと同一チェック
          if (this.newPassword == this.oldPassWord) {
            this.isErrorNewPswInput = true;
            this.isErrorReNewPassword = true;
            this.errors.push(
              Common.createError("MTCL1092", Common.getMessage("MTCL1092"))
            );
            this.retstatus = false;
          }
          if (!this.retstatus) return;
    
          this.$emit("send", this.reNewPassword);
          this.reset();
        },
        // *****************************************
        // キャンセル
        // **********************************************
        cancelAction() {
          this.$emit("cancel");
          this.reset();
          this.isErrorNewPswInput = false;
          this.isErrorReNewPassword = false;
          this.errors = [];
          this.errors_newpass = [];
          this.errors_renewpass = [];
        },
        // **********************************************
        // リセット
        // **********************************************
        reset() {
          this.newPassword = "";
          this.reNewPassword = "";
        },
        // **********************************************
        // 初期フォーカス設定
        // **********************************************
        initFocus() {
          this.$refs.refPassword1Input.focus();
        },
      },
    };
    </script>
    <style scoped>
    .loginbox {
      height: 520px;
    }
    
    .popup{
      width: 500px; 
      height: 520px;
    }
    
    @media screen and (max-width: 768px) {
      .loginbox {
        width: 100%;
        min-width: 100%;
        max-width: 100%;
        height: unset;
      }
    
      .popup{
        width:  calc(100vw - 30px); 
        height: unset;
      }
      .login-btn {
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    
      .frm-btn {
        margin-top: 20px;
      }
      .login-label{
        margin-left:calc((100% - 240px)/2);
      }
    
      .frm-btn+.frm-btn {
        margin-left: 0px;
      }
    
      .errMsg.ml-100px {
        margin-left:calc((100% - 240px)/2);
      }
    }
    
    
    </style>
    